import { render, staticRenderFns } from "./null-input.vue?vue&type=template&id=2b29edb8&"
import script from "./null-input.vue?vue&type=script&lang=js&"
export * from "./null-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports